import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, Form, submit, reduxForm } from 'redux-form/immutable';
import { TextField } from 'redux-form-material-ui';
import _ from 'lodash';

import FlatButton from 'material-ui/FlatButton';

import ReduxDialog from '../Common/ReduxDialog';
import { required } from '../../utils/formvalidation';
import { hideDialog } from '../../actions/dialogs';
import { id } from '../../utils/helper';

import commonStyles from '../styles';
import styles from './styles';

class RoleDialog extends React.Component {
  static propTypes = {
    role: PropTypes.object.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
  };

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.onRequestClose()}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => this.props.submit('role')}
      />,
    ];

    return (
      <ReduxDialog
        name="role"
        title="Role"
        actions={actions}
        autoScrollBodyContent
      >
        <Form onSubmit={handleSubmit}>
          <div style={styles.row}>
            <Field
              name="name"
              component={TextField}
              floatingLabelText="Name"
              floatingLabelFixed
              fullWidth
              style={commonStyles.input}
              validate={[required]}
            />
          </div>
        </Form>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'role',  // a unique identifier for this form
  // onSubmit: (values, dispatch, props) => {
  //   const job = values
  //     .set('profile', fromJS(props.job.profile || {}))
  //     .set('taskProfiles', fromJS(props.job.taskProfiles || []))
  //     .set('resources', fromJS(props.job.resources || {}))
  //     .set('preferredItems', fromJS(props.job.preferredItems || {}))
  //     .set('tasks', fromJS(props.job.tasks || { count: 0 }));
  //   // console.log('creating job', job.toJS());
  //   // const data = fromJS({ tasks: props.tasks }).set('job', job);
  //   return dispatch(saveJobRoutine.trigger(job));
  // },
  onSubmit: (values, dispatch, props) => {
    props.onRequestClose(_.assign({ id: id() }, values.toJS()));
    props.hideDialog('role');
  },
})(RoleDialog);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    submit,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state, props) {
  return {
    // currentUser: state.get('authentication').get('user'),
    // role: state.get('roles').get('role').toJS(),
    initialValues: props.role,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);


// WEBPACK FOOTER //
// ./src/components/RoleDialog/index.js